import Butter from 'buttercms'	

export default Butter('d3b91cfb3c0e6de08ddf9b90911204b6b8defe3c', false, 2000) 	